export default __webpack_public_path__ + "static/media/10.be7f7412.png";